import '../../scss/news.scss';

import '../common/share';
import '../common/slider';
import Player from "@vimeo/player";

const container = document.querySelector('#header');
const bannerContent = document.querySelector('.banner-news-content');
document.addEventListener('DOMContentLoaded', () => {
    initPlayers();

    if (bannerContent !== null) {
        window.addEventListener('scroll', triggerBannerContent, {
            passive: true,
            capture: true
        });
    }
});

const triggerBannerContent = () => {
    if (window.scrollY > container.offsetTop) {
        bannerContent.classList.add('active');
    } else {
        bannerContent.classList.remove('active');
    }
};

const initPlayers = () => {
    const players = document.querySelectorAll('.player');
    Array.from(players).forEach(playerCtn => {
        new Player(playerCtn, {
            url: playerCtn.getAttribute('data-video-url'),
            byline: false,
            portrait: false,
            color: 'FFFFFF',
            pip: true
        });
    });
}
